import { render, staticRenderFns } from "./TransactionFraudBadge.vue?vue&type=template&id=5ab1ca7f&scoped=true&"
import script from "./TransactionFraudBadge.vue?vue&type=script&lang=js&"
export * from "./TransactionFraudBadge.vue?vue&type=script&lang=js&"
import style0 from "./TransactionFraudBadge.vue?vue&type=style&index=0&id=5ab1ca7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab1ca7f",
  null
  
)

export default component.exports